// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RoomAvatar component styles - 40x40 base size with dual avatar support */

.room-avatar-container {
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

/* Single avatar - full 40x40 size */
.room-avatar-single {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

/* Dual avatars - 28.8x28.8 overlayed */
.room-avatar-first {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: -0.8px;
  left: -0.8px;
  border-radius: 50%;
  object-fit: cover;
}

.room-avatar-second {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: 12px;
  left: 12px;
  border-radius: 50%;
  object-fit: cover;
}

/* Placeholder avatars with initials - single */
.room-avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}

/* Placeholder avatars with initials - dual first */
.room-avatar-placeholder-first {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: -0.8px;
  left: -0.8px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
}

/* Placeholder avatars with initials - dual second */
.room-avatar-placeholder-second {
  position: absolute;
  width: 28.8px;
  height: 28.8px;
  margin: 0px;
  top: 12px;
  left: 12px;
  border-radius: 50%;
  background-color: #000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/RoomAvatar.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":["/* RoomAvatar component styles - 40x40 base size with dual avatar support */\n\n.room-avatar-container {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n/* Single avatar - full 40x40 size */\n.room-avatar-single {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Dual avatars - 28.8x28.8 overlayed */\n.room-avatar-first {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: -0.8px;\n  left: -0.8px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.room-avatar-second {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: 12px;\n  left: 12px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Placeholder avatars with initials - single */\n.room-avatar-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/* Placeholder avatars with initials - dual first */\n.room-avatar-placeholder-first {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: -0.8px;\n  left: -0.8px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n/* Placeholder avatars with initials - dual second */\n.room-avatar-placeholder-second {\n  position: absolute;\n  width: 28.8px;\n  height: 28.8px;\n  margin: 0px;\n  top: 12px;\n  left: 12px;\n  border-radius: 50%;\n  background-color: #000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
